(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !window.DesignMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
      window.addEventListener('DOMContentLoaded', () => {
        document.addEventListener('click', (event) => {
          if (!this.elements.button.contains(event.target)) {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.classList.add('height-hidden');
          }
        });
      });

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    }

    hidePanel() {
      this.elements.panel.classList.add('height-hidden');
      this.elements.button.setAttribute('aria-expanded', 'false');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    toggleSelector() {
      this.elements.panel.classList.toggle('height-hidden');
      if (this.elements.panel.classList.contains('height-hidden')) {
        this.elements.button.setAttribute('aria-expanded', 'false');
      } else {
        this.elements.button.setAttribute('aria-expanded', 'true');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerMenuHeight = document.querySelector('.header__inline-menu').clientHeight;
      this.positionHeader();
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler);
      this.createObserver();
      window.addEventListener('resize', () => {
        this.positionHeader();
      });

      const resizeObserver = new ResizeObserver(function (entries) {
        let rect = entries[0].contentRect;
        let height = parseInt(rect.height);
        document.getElementById('shopify-section-header').style.top = height + 'px';
      });

      // start observing for resize
      resizeObserver.observe(document.getElementById('shopify-section-announcement-bar'));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      let headerMenu = document.querySelector('.header__inline-menu');
      let headerItems = headerMenu.querySelector('.list-menu');
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight + announcementBar.clientHeight) {
        requestAnimationFrame(this.reveal.bind(this));
        headerMenu.style.transform = 'translateY(-100px)';
        headerMenu.style.visibility = 'hidden';
        document.querySelector('body').classList.remove('scrolling-up');
        document.querySelector('body').classList.add('body-header-hidden');
      } else if (scrollTop < this.currentScrollTop) {
        requestAnimationFrame(this.hide.bind(this));
        headerMenu.style.transform = 'translateY(0px)';
        headerMenu.style.visibility = 'visible';
        document.querySelector('body').classList.add('scrolling-up');
        document.querySelector('body').classList.remove('body-header-hidden');
      }

      this.currentScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    hide() {
      let headerMenu = document.querySelector('.header__inline-menu');
      if (document.querySelector('.reviews-page .reviews-widget')) {
        let reviewsFilterElm = document.querySelector('.reviews-filter');
        if (reviewsFilterElm.classList.contains('fixed')) {
          reviewsFilterElm.style.top =
            document.getElementById('shopify-section-announcement-bar').offsetHeight +
            document.getElementById('shopify-section-header').offsetHeight +
            10 +
            'px';
        } else {
          reviewsFilterElm.style.top = '0px';
        }
      }

      if (document.querySelector('.dictionary-list__name--wrapper')) {
        let dictionaryListElm = document.querySelector('.dictionary-list__name--wrapper');
        dictionaryListElm.style.top =
          document.getElementById('shopify-section-announcement-bar').offsetHeight +
          document.getElementById('shopify-section-header').offsetHeight +
          10 +
          'px';
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      this.header.classList.remove('shopify-section-header-hidden');
      if (document.querySelector('.reviews-page .reviews-widget')) {
        let reviewsFilterElm = document.querySelector('.reviews-filter');
        if (reviewsFilterElm.classList.contains('fixed')) {
          reviewsFilterElm.style.top =
            document.getElementById('shopify-section-announcement-bar').offsetHeight + this.offsetHeight + 10 + 'px';
        } else {
          reviewsFilterElm.style.top = '0px';
        }
      }

      if (document.querySelector('.dictionary-list__name--wrapper')) {
        let dictionaryListElm = document.querySelector('.dictionary-list__name--wrapper');
        dictionaryListElm.style.top =
          document.getElementById('shopify-section-announcement-bar').offsetHeight + this.offsetHeight + 10 + 'px';
      }
    }

    reset() {
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      document.querySelector('body').classList.remove('body-header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    positionHeader() {
      const announcementBarHeight = document
        .getElementById('shopify-section-announcement-bar')
        .getBoundingClientRect().height;
      this.parentElement.style.position = 'sticky';
      this.parentElement.style.top = announcementBarHeight - 1 + 'px';
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelector('#second_close').addEventListener('click', function () {
    document.querySelector('#first_close').click();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.account-details') && document.querySelector('.account-details')) {
      document.querySelector('.account-details').removeAttribute('open');
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
   class SectionArticleElement extends HTMLElement {
        constructor() {
           super();
            let container = this;
            this.static = container.querySelector('.collection-hero__text-wrapper');
            this.sticky = container.querySelector('.collection-hero__image-container');
            let ItemText = container.querySelector('.collection-hero__text-wrapper').offsetHeight;
            if (this.sticky) {
              this.sticky.style.height = ItemText + 'px';
            }
            window.addEventListener('scroll', function() {
              container.renderSticky();
            })

            window.addEventListener('resize', function() {
              ItemText = container.querySelector('.collection-hero__text-wrapper').offsetHeight;

              if(window.innerWidth > 990) {
                container.querySelector('.collection-hero__image-container').style.height = ItemText + 'px';
              }
    
            })
        }
        renderSticky() {
          let annoucementBarHeight = 0;
          let header = document.getElementById('shopify-section-header');
          if(document.getElementById('#shopify-section-announcement-bar') != undefined){
            announcementBarHeight = document.getElementById('shopify-section-announcement-bar').offsetHeight;
          }

          let topHeight = annoucementBarHeight + header.offsetHeight;
          if (this.sticky == undefined ) { return }
          if (this.sticky.classList.contains('sticky')) {
            this.sticky.style.top = topHeight + 'px';
          } else {
            this.sticky.style.top = 0;
          }
        }
   }
   customElements.define('article-element', SectionArticleElement);
   
   class MobileCollectionHeroManager {
    constructor() {
      this.collectionHero = document.querySelector('.collection-hero__image-container.mobile');
      this.productGrid = document.querySelector('.product-grid-container');
      this.productGrid.appendChild(this.collectionHero);
    }
  }

  const mobileCollectionHeroManager = new MobileCollectionHeroManager();

  } catch(e) { console.error(e); }
})();
})();
